/* Rendered collection filters; sorting and URL state are opt-in on collection pages. */
(function () {
  'use strict';

  if (window.mtCollectionController) {
    window.mtCollectionController.mount(document);
    return;
  }

  const controllers = new WeakMap();
  const filters = ['all', 'rectangular', 'round'];
  const sorts = ['manual', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending'];
  const collator = new Intl.Collator('en-GB', { sensitivity: 'base', numeric: true });

  function initialise(root) {
    if (controllers.has(root)) return;

    const controls = root.querySelector('[data-mt-filters]');
    const buttons = controls ? Array.from(controls.querySelectorAll('[data-mt-filter]')) : [];
    const items = Array.from(root.querySelectorAll('.mt-selection__item[data-mt-shape]'));
    const grid = root.querySelector('.mt-selection__grid');
    const status = root.querySelector('[data-mt-collection-status]');
    const empty = root.querySelector('[data-mt-empty]');
    const toolbar = root.querySelector('[data-mt-toolbar]');
    const sortControl = root.querySelector('[data-mt-sort]');
    const persistent = root.dataset.mtPersist === 'true';
    const storageKey = 'mt-collection:' + window.location.pathname + ':' + root.dataset.mtSourceCollection;
    const originalOrder = new Map(items.map(function (item, index) { return [item, index]; }));
    let state = { filter: 'all', sort: 'manual' };
    let appliedSort = 'manual';
    if (!controls || !buttons.length || !items.length || !grid) return;

    function normalise(candidate) {
      return {
        filter: filters.includes(candidate.filter) ? candidate.filter : 'all',
        sort: sortControl && sorts.includes(candidate.sort) ? candidate.sort : 'manual'
      };
    }

    function readState(useSaved) {
      if (!persistent) return { filter: 'all', sort: 'manual' };
      const params = new URL(window.location.href).searchParams;
      if (params.has('shape') || params.has('sort_by')) {
        return normalise({ filter: params.get('shape'), sort: params.get('sort_by') });
      }
      if (useSaved) {
        try {
          const saved = JSON.parse(window.sessionStorage.getItem(storageKey));
          if (saved) return normalise(saved);
        } catch (error) { /* URL state still works if storage is unavailable. */ }
      }
      return { filter: 'all', sort: 'manual' };
    }

    function remember() {
      if (!persistent) return;
      const url = new URL(window.location.href);
      if (state.filter === 'all') url.searchParams.delete('shape');
      else url.searchParams.set('shape', state.filter);
      if (state.sort === 'manual') url.searchParams.delete('sort_by');
      else url.searchParams.set('sort_by', state.sort);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) { /* Filtering does not depend on browser storage. */ }
    }

    function reorder(sort) {
      if (sort === appliedSort) return;
      const ordered = items.slice().sort(function (a, b) {
        let difference = 0;
        if (sort.indexOf('price-') === 0) {
          difference = Number(a.dataset.mtPrice) - Number(b.dataset.mtPrice);
        } else if (sort.indexOf('title-') === 0) {
          difference = collator.compare(a.dataset.mtTitle || '', b.dataset.mtTitle || '');
        }
        if (sort.endsWith('-descending')) difference *= -1;
        return difference || originalOrder.get(a) - originalOrder.get(b);
      });
      const fragment = document.createDocumentFragment();
      ordered.forEach(function (item) { fragment.appendChild(item); });
      grid.appendChild(fragment);
      appliedSort = sort;
    }

    function select(candidate, save) {
      state = normalise(candidate);
      reorder(state.sort);
      let visible = 0;

      items.forEach(function (item) {
        const matches = state.filter === 'all' || item.dataset.mtShape === state.filter;
        item.hidden = !matches;
        if (matches) visible += 1;
      });
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.mtFilter === state.filter));
      });

      root.dataset.mtActiveFilter = state.filter;
      root.dataset.mtActiveSort = state.sort;
      if (sortControl) sortControl.value = state.sort;
      if (empty) empty.hidden = visible !== 0;
      if (status) {
        const description = state.filter === 'all' ? '' : state.filter + ' ';
        status.textContent = visible + ' ' + description + (visible === 1 ? 'watch' : 'watches') + ' shown.';
      }
      if (save) remember();
    }

    controls.addEventListener('click', function (event) {
      const button = event.target instanceof Element ? event.target.closest('[data-mt-filter]') : null;
      if (!button || !controls.contains(button)) return;
      select({ filter: button.dataset.mtFilter, sort: state.sort }, true);
    });
    if (sortControl) {
      sortControl.addEventListener('change', function () {
        select({ filter: state.filter, sort: sortControl.value }, true);
      });
    }

    const navigation = window.performance && window.performance.getEntriesByType('navigation')[0];
    const restore = function (useSaved) { select(readState(useSaved), false); };
    controllers.set(root, { restore: restore });
    restore(Boolean(navigation && navigation.type === 'back_forward'));
    controls.hidden = false;
    if (toolbar) toolbar.hidden = false;
    root.dataset.mtCollectionReady = 'true';
  }

  function mount(scope) {
    if (scope instanceof Element && scope.matches('[data-mt-collection]')) initialise(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-mt-collection]').forEach(initialise);
  }

  function restorePages(useSaved) {
    document.querySelectorAll('[data-mt-collection][data-mt-persist="true"]').forEach(function (root) {
      const controller = controllers.get(root);
      if (controller) controller.restore(useSaved);
    });
  }

  window.mtCollectionController = { mount: mount };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  } else {
    mount(document);
  }
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  window.addEventListener('popstate', function () { restorePages(false); });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) restorePages(true);
  });
}());
